<div *ngIf="isInProgress">
  <app-spinner></app-spinner>
</div>

<!-- Content Header (Page header) -->
<section class="content-header">
  <div class="content-header">
     <div class="container-fluid">
       <div class="row mb-2">
         <div class="col-sm-6">
             <h3>All Stock</h3>
         </div>
         <div class="col-sm-6">
           <ol class="breadcrumb float-sm-right">
             <li class="breadcrumb-item"><a routerLink="/"><i class="nav-icon fas fa-tachometer-alt"></i>&nbsp;Dashboard</a></li>
             <li class="breadcrumb-item active">All Stock</li>
           </ol>
         </div><!-- /.col -->
       </div><!-- /.row -->
     </div><!-- /.container-fluid -->
  </div>
</section>
<section class="content">
  <div class="container-fluid">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">All Stock</h3>
      </div>
      <div class="card-body">
<ag-grid-angular
  class="ag-theme-quartz"
  style="width: 100%; height: 650px;"
  [rowData]="vehicles"
  [columnDefs]="colDefs"
  [animateRows]="true"
  [pagination]="true"
  [paginationPageSize]="20"
    />
  </div>
  </div>
  </div>
</section>
